














import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/tenant/components';
import * as Common from '@/tenant/common';

@Component
export default class AtcConversion extends Vue {
  @Prop({ default: '' }) public title: string;
  @Prop({ default: null }) public value?: any | Common.IMasterItem;
  @Prop({ default: false }) public required: boolean;
  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: null }) public commodity: Common.Commodity;
  @Prop() public tooltip: string;
  @Prop({ default: true }) public isDirectEditEnabled: boolean;
  public isEdit: boolean = true;
  public validator: Components.ControlValidator = null;

  public showPopover :boolean = false;
  public target: HTMLElement = null;
  public schedule: Common.CommodityScheduleResult = null;

  public created() {
    //親Editorに登録する
    if (this.editor != null) this.editor.addControl(this);
  }
  destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }  
  public get internalValue(): string {
    return this.value;
  }
    
  public set internalValue(value: string) {
    // 親コンポーネント側で更新
    this.$emit('update:value', value);
  }

  public queryProvider(search:string, perPage:number,currentPage:number,commodity:Common.Commodity){
    var temp = new Common.ConversionMasterQuery();
    temp.search = search ? search : '';
    temp.perPage = perPage;
    temp.currentPage = currentPage;
    temp.commodity = commodity ? commodity : null;
    return temp;
  }

   @Watch('commodity')
    onCommodityChanged(newCommodity:Common.Commodity, oldCommodity:Common.Commodity) {
      if(this.isEdit == false) return;
      var oldCommodityId:number = oldCommodity == null ? 0 : oldCommodity.id;
      if(newCommodity == null || (oldCommodity != null && newCommodity.id != oldCommodityId)){
        this.$emit('update:value', null);
      }
    }

    public showEditor = false;
    public onPopupClicked(){
      this.showEditor = true;
    }      
    public onEditorClosing(arg : any){
      var obj = ((this.$refs.editor as Components.Conversion).$refs.mainList as Components.ListView).selected;
      if (! obj.initialSavedOn) return; //未保存の場合はキャンセル可
      if ((obj as Common.MasterBase).state != Common.MasterBaseStatus.Posted) {
        arg.canceled = true;
        this.$api.modal.show('無効な操作','編集画面を閉じる前に確定してください。', true,null);      
        return;
      }
      //オブジェクトを更新する
      this.$emit('update:value', obj);    
    }    
}
